import { getTranslation } from 'src/i18n';

export const functionMapping ={
  "formatkWh": formatkWh,
  "dynamickWhTitle": dynamickWhTitle,
  "dynamickWhHelpText": dynamickWhHelpText,
  'roundAverageMessageTime': roundAverageMessageTime,
  'dynamickWhForcedOnTitle': dynamickWhForcedOnTitle,
  'dynamicForcedOnkWhHelpText': dynamicForcedOnkWhHelpText,
  'formatForcedOnRatio': formatForcedOnRatio
};
/// kWh functions
export function formatkWh  (stat)  {
  let newValue = stat; // kWh
  if (stat === '-') {
    return '-';
  }
  if (stat >= 1000000) { // gWh
    newValue = stat / 1000000;
  }
  else if (stat >= 1000) { // mWh
    newValue = stat / 1000;
  }
  newValue = Math.round(newValue);

  return newValue;
}

export function dynamickWhTitle  (value)  {
  if (value>=1000000) {
    return 'Total GWh';
  }
  if (value>=1000) {
    return 'Total MWh';
  }
  return 'Total kWh';
}
export function dynamickWhForcedOnTitle  (value)  {
  let scale = 'kWh';
  if (value>=1000000) {
    scale = 'GWh';
  }
  if (value>=1000) {
    scale = 'MWh';
  }

  return getTranslation('stats.totalWastedWithScale', { variables: { scale } });
}

export function dynamickWhHelpText (value)  {
  let scale = 'kWh';
  if (value>=1000000) {
    scale = 'GWh';
  }
  if (value>=1000) {
    scale = 'MWh';
  }

  return getTranslation('stats.dynamickWhHelpText', { variables: { scale } });
}

export function dynamicForcedOnkWhHelpText (value)  {
  let scale = 'kWh';
  if (value>=1000000) {
    scale = 'GWh';
  }
  if (value>=1000) {
    scale = 'MWh';
  }

  return getTranslation('stats.dynamicForcedOnkWhHelpText', { variables: { scale } });
}

export function roundAverageMessageTime (value: string)  {
  const number = parseFloat(value);
  if (number === -1) {
    return 'N/A';
  }
  return `${number?.toFixed(0)} ms`;
}

export function formatForcedOnRatio (stat) {
  if (!stat || typeof stat !== 'object') return 'N/A';
  const logged = stat.get ? stat.get('logged', 'N/A') : stat.logged;
  const detected = stat.get ? stat.get('detected', 'N/A') : stat.detected;
  return `${logged}/${detected}`;
}

const gwhCheck = 1000000;
const mwhCheck = 10000; // is more then 1000 so that more can be in the kwh

export function getKWHTitle (maxKWhInGraph) {
  let powerTitle = 'kWh';
  if (maxKWhInGraph > gwhCheck) powerTitle = 'GWh';
  else if (maxKWhInGraph > mwhCheck) powerTitle = 'MWh';

  return powerTitle;
}

export function getConvertAllGraphValuesBasedOnMaxKwh (maxKWhInGraph) {
  let convert =  (value) => (value);
  if (maxKWhInGraph > gwhCheck) convert = (value) => (Math.round(value/1000000));
  else if (maxKWhInGraph > mwhCheck) convert = (value) => (Math.round(value/1000));

  return convert;
}
